import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import $ from 'jquery';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import DesignerForm from '../../components/DesignerForm';
import PMForm from '../../components/PMForm';
import countries from '../../util/countries';
import styles from './styles.scss';

const initialState = {
  applicationType: 'Designer',
  fullName: '',
  phoneNumber: '',
  city: '',
  timeZone: '',
  country: '',
  email: '',
  websiteURL: '',
  dribbbleURL: '',
  linkedInURL: '',
  employer: '',
  position: '',
  teamSize: '',
  characteristic: '',
  fitDescription: '',
  processDescription: '',
  heardAboutUs: '',
  availability: '',
  hourlyRate: '',
  designTypes: [],
  sending: false
};

class Apply extends Component {
  state = {
    ...initialState
  };

  render() {
    const {
      applicationType,
      fullName,
      email,
      phoneNumber,
      city,
      timeZone,
      country,
      websiteURL,
      dribbbleURL,
      linkedInURL,
      employer,
      position,
      teamSize,
      characteristic,
      fitDescription,
      processDescription,
      heardAboutUs,
      availability,
      hourlyRate,
      designTypes,
      sending
    } = this.state;

    const designerFormProps = {
      websiteURL,
      dribbbleURL,
      employer,
      availability,
      designTypes,
      hourlyRate,
      processDescription,
      onChangeField: this.onChangeField
    };

    const pmFormProps = {
      linkedInURL,
      employer,
      position,
      availability,
      designTypes,
      teamSize,
      characteristic,
      processDescription,
      onChangeField: this.onChangeField
    }

    const designerForm = applicationType === 'Designer' && (
      <DesignerForm {...designerFormProps} />
    );

    const pmForm = applicationType === 'Product Manager' && (
      <PMForm {...pmFormProps} />
    );

    return (
      <DocumentTitle title='DesignCue - Apply'>
        <div>
          <form onSubmit={this.onSubmitForm} className={`${styles.contactForm} ${styles.application}`}>
            <div className="container-fluid main-container">
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                <div className="row">
                  <div className="col-md-9 col-center mt50">
                    <div className="text-center">
                      <h1 className="mb40">
                        Want to join DesignCue?
                      </h1>
                      <p className="h3 alt-text mb10">
                        DesignCue is an invite-only network of top designers and product managers.
                        To apply, fill out the form below and we'll be in touch.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid main-container">
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                <div className="row">
                  <div className="col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-12">
                    <div className="form-group mtb100">
                      <div className="row">
                        <div className="col-sm-5">
                          <label className={`btn btn-block btn-dc-primary ${styles.applicationType} ${applicationType === 'Designer' ? 'inverse' : ''}`}>
                            APPLY AS A DESIGNER
                            <input
                              type="radio"
                              id="applicationType"
                              name="applicationType"
                              value="Designer"
                              onChange={this.onChangeField}
                            />
                          </label>
                        </div>
                        <div className="col-sm-7">
                          <label className={`btn btn-block btn-dc-primary ${styles.applicationType} ${applicationType === 'Product Manager' ? 'inverse' : ''}`}>
                            APPLY AS A PRODUCT MANAGER
                            <input
                              type="radio"
                              id="applicationType"
                              name="applicationType"
                              value="Product Manager"
                              onChange={this.onChangeField}
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid main-container">
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                <div className="row">
                  <div className="col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-12">
                    <div className="form-group">
                      <label className="bold" htmlFor="fullName">YOUR NAME</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="fullName"
                        placeholder="Enter full name"
                        name="fullName"
                        value={fullName}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="email">EMAIL</label>
                      <input
                        type="email"
                        className="form-control input-lg"
                        id="email"
                        placeholder="Enter your Email"
                        name="email"
                        value={email}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="phoneNumber">PHONE NUMBER</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="phoneNumber"
                        placeholder="e.g. (404) 444-4444"
                        name="phonenumber"
                        value={phoneNumber}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="country">YOUR COUNTRY OF RESIDENCE</label>
                      <Select
                        name="country"
                        placeholder="Select Country"
                        clearable={false}
                        searchable={false}
                        value={country}
                        options={countries.map(country => { return {value: country, label: country} })}
                        onChange={this.onSelectCountry}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="city">CITY</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="city"
                        placeholder="Enter your City"
                        name="city"
                        value={city}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="timeZone">TIME ZONE</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="timeZone"
                        placeholder="Enter your Time Zone"
                        name="timeZone"
                        value={timeZone}
                        onChange={this.onChangeField}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            {designerForm}
            {pmForm}
            <hr />
            <div className="container-fluid main-container">
              <div className="col-md-10 col-md-offset-1 col-sm-12">
                <div className="row">
                  <div className="col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-12">
                    <div className="form-group">
                      <label className="bold" htmlFor="fitDescription">WHY ARE YOU A GOOD FIT FOR DESIGNCUE?</label>
                      <textarea
                        className="form-control input-lg"
                        rows="5"
                        id="fitDescription"
                        placeholder="Enter your reason"
                        name="fitDescription"
                        value={fitDescription}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="form-group">
                      <label className="bold" htmlFor="heardAboutUs">WHERE DID YOU HEAR ABOUT DESIGNCUE?</label>
                      <input
                        type="text"
                        className="form-control input-lg"
                        id="heardAboutUs"
                        placeholder="Enter how you heard"
                        name="heardAboutUs"
                        value={heardAboutUs}
                        onChange={this.onChangeField}
                      />
                    </div>
                    <div className="row">
                      <div className="col-xs-12 text-right mb100">
                        <button className="btn btn-dc-blue btn-xs-block" disabled={sending} type="submit">JOIN US</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </DocumentTitle>
    );
  }

  onChangeField = (event) => {
    if (event.target.id === 'designTypes') {
      const twoDesignTypes = this.state.designTypes;
      if (twoDesignTypes.length === 2 && !twoDesignTypes.includes(event.target.value)) {
        return;
      }
      if (twoDesignTypes.includes(event.target.value)) {
        const index = twoDesignTypes.indexOf(event.target.value);
        if (index > -1) {
          twoDesignTypes.splice(index, 1);
        }
        this.setState({
          [event.target.id]: twoDesignTypes
        });
        return;
      }
      twoDesignTypes.push(event.target.value);
      this.setState({
        [event.target.id]: twoDesignTypes
      });
    } else {
      this.setState({
        [event.target.id]: event.target.value
      });
    }
  }

  onSelectCountry = (country) => {
    this.setState({
      country: country.value
    });
  }

  onSubmitForm = (event) => {
    event.preventDefault();
    this.setState({
      sending: true
    }, this.sendFormData);
  }

  sendFormData = () => {
    const formData = {
      "application_type": this.state.applicationType,
      "full_name": this.state.fullName,
      "email": this.state.email,
      "phone_number": this.state.phoneNumber,
      "country": this.state.country,
      "city": this.state.city,
      "time_zone": this.state.timeZone,
      "website_URL": this.state.websiteURL,
      "dribbble_URL": this.state.dribbbleURL,
      "linkedin_URL": this.state.linkedInURL,
      "employer": this.state.employer,
      "position": this.state.position,
      "availability": this.state.availability,
      "design_types": this.state.designTypes,
      "hourly_rate": this.state.hourlyRate,
      "teamSize": this.state.teamSize,
      "process_description": this.state.processDescription,
      "greatest_characteristic": this.state.characteristic,
      "good_fit_description": this.state.fitDescription,
      "heard_about_designcue": this.state.heardAboutUs
    };

    $.ajax({
      url: 'https://formspree.io/pa@designcue.co',
      method: 'POST',
      dataType: 'json',
      data: {
        ...formData
      },
      success: function(res) {
        this.setState({ ...initialState }, this.props.submitSuccess('application'));
      }.bind(this),
      error: function(xhr, status, err) {
        console.error(status, err.toString());
      }
    });
  }
}

export default Apply;



// WEBPACK FOOTER //
// ./src/pages/Apply/index.js